import { AppErrorCode } from '../api/errors.js';
/**
 * Русский словарь — эталонный. Типы остальных локалей выводятся из него, поэтому
 * добавление ключа сюда сразу подсвечивает пропуск в других языках.
 */
export const ru = {
    common: {
        back: 'Назад',
        cancel: 'Отмена',
        yes: 'Да',
        no: 'Нет',
        close: 'Закрыть',
        retry: 'Повторить',
        loading: 'Загрузка…',
        continue: 'Продолжить',
        somethingWentWrong: 'Что-то пошло не так',
        minutesShort: 'мин.',
        secondsShort: 'с',
    },
    /** Вход через бота: одни и те же слова на лендинге и в диалоге. */
    auth: {
        action: 'Войти через Telegram',
        waiting: 'Ждём подтверждения в Telegram…',
        openAgain: 'Открыть Telegram ещё раз',
        cancel: 'Отмена',
        expired: 'Ссылка устарела. Попробуйте войти снова.',
        failed: 'Не удалось начать вход. Попробуйте ещё раз.',
    },
    onboarding: {
        welcomeTitle: 'Анонимный чат',
        welcomeSubtitle: 'Общайтесь с новыми людьми. Без имён и телефонов.',
        welcomeAction: 'Начать',
        genderTitle: 'Ваш пол',
        genderSubtitle: 'Это поможет подобрать собеседника',
        male: 'Мужчина',
        female: 'Женщина',
        topicTitle: 'Тема общения',
        topicSubtitle: 'От неё зависит, кого мы будем искать',
        topicFlirt: 'Флирт',
        topicChat: 'Общение',
        topicFlirtHint: 'Только собеседники противоположного пола',
        topicChatHint: 'Любые собеседники — выберите, кого искать',
        aboutYou: 'Вы',
        preferenceTitle: 'Кого ищем',
        searchAgain: 'Искать дальше',
        changeSettings: 'Выйти к настройкам',
        searchAgainHint: 'Можно сразу найти нового собеседника с теми же параметрами.',
        preferenceMale: 'Мужчину',
        preferenceFemale: 'Женщину',
        preferenceAny: 'Любого',
        ageTitle: 'Сколько вам лет?',
        ageSubtitle: 'Собеседники увидят только диапазон, а не точный возраст',
        partnerAgeTitle: 'Возраст собеседника',
        partnerAgeSubtitle: 'Выберите диапазон, в котором искать',
        ageFrom: 'от',
        ageTo: 'до',
        yourAge: 'Ваш возраст: {age}',
        startSearch: 'Начать поиск',
        minimumAgeNotice: 'Сервис доступен только совершеннолетним',
    },
    landing: {
        title: 'Анонимный чат',
        subtitle: 'Случайный собеседник за пару секунд. Без регистрации, без имён и номеров телефона.',
        action: 'Начать чат',
        notice: 'Нажимая кнопку, вы принимаете правила сервиса.',
        features: {
            anonymous: {
                title: 'Полная анонимность',
                text: 'Собеседник не видит ни имени, ни фотографии, ни контактов.',
            },
            instant: {
                title: 'Мгновенный подбор',
                text: 'Пара находится за секунды: по теме, полу и возрасту.',
            },
            private: {
                title: 'Ничего не нужно указывать',
                text: 'Ни телефона, ни почты, ни подтверждений — сразу к разговору.',
            },
        },
        telegramOpenApp: 'Открыть в Telegram',
        telegramTitle: 'Пользуйтесь с любого устройства',
        telegramText: 'В Telegram чат открывается прямо в приложении: диалоги и настройки остаются с вами на телефоне, планшете и компьютере.',
        savedTitle: 'Сохраняйте собеседников',
        savedText: 'Понравился человек — предложите подружиться прямо в разговоре. Диалог сохранится у обоих, и к нему можно вернуться через день или через месяц: история переписки останется на месте.',
        rulesLink: 'Правила',
        termsLink: 'Правила пользования',
        privacyLink: 'Политика конфиденциальности',
        contactEmail: 'hello@ghostly.im',
        copyright: '{domain} © {year}',
    },
    /**
     * Прозвище собеседника: прилагательное и существительное, новое в каждом
     * диалоге. Все существительные мужского рода — иначе прилагательное с ними
     * не согласуется.
     */
    nicknames: {
        adjectives: [
            'Тихий', 'Смелый', 'Хитрый', 'Шумный', 'Сонный', 'Быстрый', 'Мудрый', 'Дерзкий',
            'Лохматый', 'Вежливый', 'Пятнистый', 'Полосатый', 'Задумчивый', 'Весёлый', 'Ловкий',
            'Упрямый', 'Рыжий', 'Синий', 'Зелёный', 'Серебристый', 'Пушистый', 'Колючий',
            'Северный', 'Осенний', 'Полуночный', 'Утренний', 'Дальний', 'Лесной', 'Морской',
            'Горный', 'Странствующий', 'Молчаливый', 'Любопытный', 'Бодрый', 'Важный',
            'Учёный', 'Отчаянный', 'Бархатный', 'Медный', 'Янтарный',
        ],
        nouns: [
            'Странник', 'Кит', 'Ёж', 'Филин', 'Барс', 'Ветер', 'Компас', 'Маяк', 'Фонарь',
            'Пингвин', 'Лис', 'Ворон', 'Барсук', 'Тюлень', 'Краб', 'Осьминог', 'Мотылёк',
            'Сверчок', 'Кактус', 'Шмель', 'Бобр', 'Енот', 'Дельфин', 'Сокол', 'Журавль',
            'Носорог', 'Верблюд', 'Суслик', 'Хомяк', 'Пеликан', 'Тукан', 'Скворец', 'Дрозд',
            'Лось', 'Марал', 'Каштан', 'Клевер', 'Сугроб', 'Кораблик', 'Пряник',
        ],
    },
    rules: {
        title: 'Правила общения',
        intro: 'Коротко о том, что здесь недопустимо. Нарушения ведут к блокировке.',
        items: [
            {
                title: 'Только совершеннолетним',
                text: 'Сервис не предназначен для лиц младше 18 лет. Если собеседник несовершеннолетний — завершите диалог и отправьте жалобу.',
            },
            {
                title: 'Уважение к собеседнику',
                text: 'Оскорбления, угрозы, травля и разжигание вражды недопустимы.',
            },
            {
                title: 'Никакого контента с несовершеннолетними',
                text: 'Материалы сексуального характера с участием детей запрещены безусловно.',
            },
            {
                title: 'Без принуждения',
                text: 'Не отправляйте материалы интимного характера без согласия собеседника и не требуйте их от него.',
            },
            {
                title: 'Без спама и рекламы',
                text: 'Ссылки на сторонние сервисы, реклама и массовые рассылки запрещены.',
            },
            {
                title: 'Берегите свои данные',
                text: 'Не сообщайте телефон, адрес, реквизиты карт и коды из СМС. Не публикуйте чужие персональные данные.',
            },
            {
                title: 'Осторожно с деньгами',
                text: 'Просьбы о переводе средств — типичный признак мошенничества. Не переводите деньги незнакомцам.',
            },
            {
                title: 'Ничего противозаконного',
                text: 'Запрещены торговля запрещёнными веществами и оружием, мошенничество и любая иная противоправная деятельность.',
            },
        ],
        reportHint: 'Столкнулись с нарушением — нажмите ⚠ в чате.',
        close: 'Понятно',
    },
    search: {
        title: 'Поиск собеседника…',
        subtitleSearching: 'Подбираем человека',
        subtitleExpanding: 'Расширяем поиск',
        position: 'Вы {position}-й в очереди',
        waiting: 'В поиске {duration}',
        cancel: 'Отменить поиск',
        timeout: 'Никого не нашли. Попробуем ещё раз?',
    },
    saved: {
        title: 'Мои чаты',
        open: 'Мои чаты',
        emptyTitle: 'Пока пусто',
        emptyText: 'Понравился собеседник — предложите подружиться прямо в диалоге. Он сохранится здесь вместе с перепиской.',
        noMessages: 'Пока ни одного сообщения',
        lastPhoto: 'Фотография',
        lastVoice: 'Голосовое сообщение',
        notificationsOn: 'Напоминания включены',
        notificationsOff: 'Напоминания выключены',
        notificationsHint: 'Бот напомнит о непрочитанном, если вы не заходили несколько часов. Одним сообщением, не на каждую реплику.',
        // Открыв приложение по прямой ссылке, человек минует переписку с ботом — и
        // писать ему бот не вправе, пока тот не разрешит.
        permissionText: 'Бот не сможет напомнить о непрочитанном, пока вы не разрешите ему писать',
        permissionAction: 'Разрешить',
    },
    chat: {
        partnerFound: 'Собеседник найден',
        anonymous: 'Анонимный пользователь',
        online: 'в сети',
        offline: 'не в сети',
        authAway: 'входит через Telegram',
        typing: 'печатает…',
        inputPlaceholder: 'Сообщение…',
        sendPhoto: 'Отправить фото',
        openPhoto: 'Открыть фото на весь экран',
        befriend: 'Подружиться',
        friends: 'В друзьях',
        friendRequestTitle: '{name} хочет добавить вас в друзья',
        friendRequestText: 'После согласия диалог сохранится у обоих, и к нему можно будет вернуться.',
        friendAccept: 'Принять',
        friendDecline: 'Отклонить',
        friendsNow: 'Вы теперь друзья',
        removeFriend: 'Удалить из друзей',
        removeFriendTitle: 'Удалить из друзей?',
        removeFriendText: 'Переписка исчезнет у обоих и восстановлению не подлежит.',
        friendGuestTitle: 'Сохраните собеседника',
        friendGuestText: 'Чтобы вернуться к этому разговору позже, войдите через Telegram: диалог сохранится у обоих вместе с историей переписки.',
        friendRequestGuestText: 'Чтобы принять, нужен вход через Telegram — так диалог сохранится и к нему можно будет вернуться.',
        friendAcceptWithLogin: 'Войти и принять',
        friendLater: 'Не сейчас',
        friendHint: 'Понравился разговор? Нажмите 🤝 вверху — диалог сохранится у обоих.',
        friendHintGuest: 'Понравился разговор? Нажмите 🤝 вверху, и диалог сохранится у обоих — для этого нужен вход через Telegram.',
        friendAlreadyTitle: 'Вы уже друзья',
        friendAlreadyText: 'Диалог сохранён — он есть в разделе «Мои чаты».',
        friendFailedTitle: 'Не удалось предложить дружбу',
        friendFailedText: 'Попробуйте ещё раз через минуту.',
        reportIssue: 'Сообщить о проблеме',
        issueTitle: 'Что-то работает не так?',
        issueText: 'Опишите, что произошло. К обращению приложатся сведения об устройстве и последние ошибки приложения — переписку мы не читаем.',
        issuePlaceholder: 'Например: не отправляется голосовое',
        issueSend: 'Отправить',
        issueSentTitle: 'Спасибо, обращение принято',
        issueSentText: 'Мы разберёмся. Если понадобится, свяжемся с вами через бота.',
        issueFailed: 'Не удалось отправить. Попробуйте позже.',
        friendSentTitle: 'Предложение отправлено',
        friendSentText: 'Собеседник увидит его в диалоге. Как только он согласится, разговор сохранится у вас обоих.',
        friendsNowTitle: 'Вы теперь друзья',
        friendsNowText: 'Диалог сохранён у вас обоих: он в разделе «Мои чаты», и вернуться к нему можно в любой момент.',
        friendDeclinedTitle: 'Собеседник отказался',
        friendDeclinedText: 'Разговор продолжается — просто он не сохранится.',
        recordVoice: 'Записать голосовое',
        voiceRecording: 'Идёт запись',
        voiceSlideToCancel: 'Влево — отмена',
        voiceHoldHint: 'Удерживайте кнопку, чтобы записать',
        voiceCancel: 'Отменить запись',
        voiceSend: 'Отправить запись',
        voiceDenied: 'Разрешите доступ к микрофону в настройках браузера',
        voiceFailed: 'Не удалось записать голосовое',
        voiceMessage: 'Голосовое сообщение',
        voiceLimitReached: 'Достигнут предел длительности — запись остановлена',
        photoTooLarge: 'Фото больше 10 МБ',
        photoUnsupported: 'Поддерживаются JPEG, PNG и WebP',
        photoUploading: 'Загрузка фото…',
        reply: 'Ответить',
        replyPhoto: 'Фотография',
        you: 'Вы',
        cancelReply: 'Отменить ответ',
        goToOriginal: 'Перейти к сообщению',
        leave: 'Завершить чат',
        partnerLeft: 'Собеседник вышел из чата',
        chatClosed: 'Чат завершён',
        connectionLost: 'Соединение потеряно. Переподключаемся…',
        delivered: 'Доставлено',
        read: 'Прочитано',
    },
    report: {
        action: 'Пожаловаться',
        confirmTitle: 'Пожаловаться на пользователя?',
        confirmText: 'Жалоба будет рассмотрена. Диалог завершится.',
        reasonTitle: 'Причина жалобы',
        reasonSpam: 'Спам и реклама',
        reasonInsult: 'Оскорбления',
        reasonPorn: 'Непристойный контент',
        reasonScam: 'Мошенничество',
        reasonUnderage: 'Несовершеннолетний',
        reasonOther: 'Другое',
        commentPlaceholder: 'Комментарий (необязательно)',
        submit: 'Отправить жалобу',
        success: 'Жалоба отправлена. Спасибо!',
        sentTitle: 'Жалоба отправлена',
        sentText: 'Мы разберёмся. Диалог закрыт, и этот собеседник больше вам не встретится в ближайшее время.',
    },
    errors: {
        [AppErrorCode.UNAUTHORIZED]: 'Сессия истекла, откройте приложение заново',
        [AppErrorCode.FORBIDDEN]: 'Действие недоступно',
        [AppErrorCode.NOT_FOUND]: 'Не найдено',
        [AppErrorCode.INVALID_INIT_DATA]: 'Не удалось подтвердить вход через Telegram',
        [AppErrorCode.INIT_DATA_EXPIRED]: 'Данные входа устарели, откройте приложение заново',
        [AppErrorCode.USER_BANNED]: 'Доступ к сервису ограничен',
        [AppErrorCode.ONBOARDING_REQUIRED]: 'Сначала заполните анкету',
        [AppErrorCode.VALIDATION_FAILED]: 'Проверьте введённые данные',
        [AppErrorCode.RATE_LIMITED]: 'Слишком часто. Подождите немного',
        [AppErrorCode.ALREADY_IN_QUEUE]: 'Поиск уже идёт',
        [AppErrorCode.NOT_IN_QUEUE]: 'Поиск не запущен',
        [AppErrorCode.ALREADY_IN_CHAT]: 'Вы уже в чате',
        [AppErrorCode.QUEUE_TIMEOUT]: 'Поиск остановлен: никого не нашли',
        [AppErrorCode.CHAT_NOT_FOUND]: 'Чат не найден',
        [AppErrorCode.CHAT_CLOSED]: 'Чат уже завершён',
        [AppErrorCode.NOT_CHAT_PARTICIPANT]: 'Вы не участник этого чата',
        [AppErrorCode.MEDIA_TOO_LARGE]: 'Файл слишком большой',
        [AppErrorCode.MEDIA_UNSUPPORTED_TYPE]: 'Такой формат файла не поддерживается',
        [AppErrorCode.MEDIA_INFECTED]: 'Файл не прошёл проверку безопасности',
        [AppErrorCode.MEDIA_UPLOAD_FAILED]: 'Не удалось загрузить файл',
        [AppErrorCode.MEDIA_NOT_FOUND]: 'Файл не найден',
        [AppErrorCode.VOICE_TOO_LONG]: 'Голосовое сообщение слишком длинное',
        [AppErrorCode.REPORT_DUPLICATE]: 'Жалоба на этот чат уже отправлена',
        [AppErrorCode.REPORT_TARGET_NOT_FOUND]: 'Пользователь не найден',
        [AppErrorCode.INTERNAL_ERROR]: 'Внутренняя ошибка. Попробуйте позже',
        [AppErrorCode.SERVICE_UNAVAILABLE]: 'Сервис временно недоступен. Попробуйте через пару минут',
    },
};
//# sourceMappingURL=ru.js.map